import { useEffect } from "react";
import { motion } from "framer-motion";
import { useLocation } from "react-router-dom";
import Container from "../components/Container";
//import project1 from "../assets/images/project1.png";
// import project2 from "../assets/images/project2.jpg";
// import project3 from "../assets/images/project3.jpg";
import { useTranslation } from "react-i18next";

function Projects() {
  const location = useLocation();
  const { t } = useTranslation();

  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  return (
    <Container>
      {/* Page transition overlay */}
      <motion.div
        initial={{
          width: "100vw",
          height: "100vh",
          borderRadius: 0,
          transformOrigin: "center",
        }}
        animate={{
          width: 0,
          height: 0,
          borderRadius: "100%",
          transformOrigin: "center",
        }}
        transition={{ duration: 0.5, ease: "easeInOut" }}
        className="absolute top-1/2 left-1/2 bg-custom-ivory z-40 -translate-x-1/2 -translate-y-1/2"
      />

      <div className="border-t border-custom-yellow-dark bg-custom-ivory w-[calc(90vw)]">
        {/* Page Heading */}
        <h1 className="text-4xl md:text-5xl text-custom-yellow text-center mt-8 mb-12">
          {t("projects.main.heading", "Our Projects")}
        </h1>

        {/* Project One (Yoga & Meditation Center – Upcoming) */}
        <motion.div
          initial={{ x: -30, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1, transition: { duration: 0.3 } }}
          viewport={{ once: true, amount: "all" }}
          className="flex flex-col md:flex-row justify-between px-4 my-10"
          id="project1"
        >
          <div className="md:w-1/2 flex flex-col justify-center items-center">
            <h1 className="text-custom-yellow text-3xl font-bold my-8">
              {t("projects.project1.heading", "Yoga & Meditation Center")}
            </h1>
            <p className="text-left text-custom-yellow-dark md:pl-9">
              {t(
                "projects.project1.para",
                "An upcoming sanctuary designed to promote inner peace, mindfulness, and holistic well-being through yoga, meditation, and spiritual practices."
              )}
            </p>
          </div>
          <div className="relative order-first md:order-2 md:w-1/2 flex justify-center">
            <img
              //src={project1}
              alt="Anand Mandir & Meditation Center"
              className="w-[calc(65%)] h-96 rounded-md shadow-lg"
            />
          </div>
        </motion.div>

        {/*
        // 🔒 Future projects (commented out for now)

        <motion.div ... id="project2">
          ...
        </motion.div>

        <motion.div ... id="project3">
          ...
        </motion.div>
        */}
      </div>
    </Container>
  );
}

export default Projects;
